import { ViewController } from "@gaming/srvg-classes-core";
import { RoundContainerView } from "../../View/RoundContainerView";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

export class RoundContainerViewController extends ViewController {
    roundContainerView: RoundContainerView;

    constructor( options ) {
        options = options || {};

        // needed for super class
        super(options);
        this.roundContainerView = options.view || null;

        app.timelineController.addSubscriberForEvent(this, PhaseChangeEvent);
    }

    handlePhaseChangeEvent( event:PhaseChangeEvent, provider ) {
        // league or group stage?
        //console.log("event.chunk.competitionStageType", event.chunk.competitionStageType);
        if (event.chunk.competitionStageType === "league"){
            this.roundContainerView.showLeagueStageData();
            this.roundContainerView.setGroups(event.chunk.getGroups());
        }else if(event.chunk.competitionStageType === 'cup'){
            this.roundContainerView.showGroupStageData();
        }
    }




}